// @flow

import type {PhotoEBadgeQueryResultDispatchProps, PhotoEBadgeQueryResultStateProps} from "../../../components/ebadge/photo/PhotoEBadgeQueryResult";
import PhotoEBadgeQueryResult from "../../../components/ebadge/photo/PhotoEBadgeQueryResult";
import type {StoreState} from "../../../reducers/combinedReducers";
import {connect} from "react-redux";
import {Dispatch} from "redux";
import {
    photoEBadgeQueryAction,
    photoEBadgeQueryStartAction,
    photoEBadgeQuerySuccessAction
} from "../../../actions/ebadge/photo/creators/photoEBadgeQueryActionCreator";
import type {PhotoEBadgeSearchCriteria} from "../../../components/ebadge/photo/PhotoEBadgeSearchForm";
import type {RoleConfig} from "../../../types/utilityTypes";
import {computeUserConfigs} from "../../../helpers/utils";
import {togglePhotoAction} from "../../../actions/ebadge/photo/creators/photoEBadgeActionCreator";

function mapStateToProps(state: StoreState): PhotoEBadgeQueryResultStateProps {

    let roleConfig: RoleConfig = computeUserConfigs(state.loginUser.roleIds);

    return {
        currentPage: state.photoEBadgeQuery.currentPage,
        eBadges: state.photoEBadgeQuery.eBadges,
        totalCount: state.photoEBadgeQuery.totalResult,
        isLoading: state.photoEBadgeQuery.isLoading,
        error: state.photoEBadgeQuery.error,
        idleTimeout: roleConfig.idleTimeout,
        enableDeleteButtons: roleConfig.allowToDelete,
        enableVerifyButtons: roleConfig.allowToVerify
    }
}

function mapDispatchToProps(dispatch: Dispatch): PhotoEBadgeQueryResultDispatchProps {
    return {
        onPageClick: (page: number, criteria: PhotoEBadgeSearchCriteria) => {

            criteria.page = page;
            dispatch(photoEBadgeQueryAction(criteria));
        },
        resetResult: () => {
            dispatch(photoEBadgeQueryStartAction({page: 0}));
            dispatch(photoEBadgeQuerySuccessAction([], 0));
        },
        togglePhoto: (registrationCode: string) => {
            dispatch(togglePhotoAction(registrationCode));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PhotoEBadgeQueryResult);


// WEBPACK FOOTER //
// ./src/containers/ebadge/photo/PhotoEBadgeQueryResult.js